import { appEntryItem } from '@/mocks/homeData';

export default function AppEntry() {
  return (
    <section id="app" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-lg p-6 md:p-10">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className={`${appEntryItem.icon} text-3xl md:text-4xl text-primary-600`}></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 mb-2">{appEntryItem.title}</h2>
            <p className="text-sm md:text-base text-primary-600 font-medium mb-3">{appEntryItem.subtitle}</p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4 max-w-2xl">{appEntryItem.description}</p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              {appEntryItem.features.map((f, i) => (
                <span key={i} className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-medium rounded-full">
                  <i className="ri-check-line text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}